<template>
    <div class="text-center white">
      <v-dialog v-model="dialog" max-width="720" persistent class="white">
        <v-card>
            <v-card-text class="px-0">
              <iframe :src="url" width="100%" height="700px" frameborder="0"></iframe>
              <div class="row px-4 ma-0">
                <div class="col-xs-12 col-sm-3">
                  <v-btn color="white" :loading="loading" class="red text-white" dark outlined tile @click="desvincularFactura()"> Desvincular </v-btn>
                </div>
                <div class="col-xs-12 col-sm-9">
                  <v-btn color="white" :loading="loading" class="grey text-white" block dark outlined tile @click="cerrar()"> Cerrar </v-btn>
                </div>
              </div>
            </v-card-text> 
          </v-card>
      </v-dialog>


      <desvincular_factura ref="refdesvincular_factura" v-on:fact_dgi_success="cerrar"></desvincular_factura>
    </div>
  </template>
  
  <script> 
import { apiviewfactura } from './facturafacil';
import desvincular_factura from './desvincular_factura.vue';

  export default {
    components:{
      desvincular_factura
    },
      data() {
        return {
          loading: true,
          dialog: false,
          url: null,
          emitir_refresh: false,
          recibo: {}
        };
      },
      methods: {
        async openmodal(prog) { 
          window.console.log('recibo ispi:::::', prog);
          this.emitir_refresh = false
          this.dialog = true; 
          this.recibo = prog      
          this.url = null 
          const cufe = prog.cufe
          const uuid = prog.uuid
          this.loading = true
          const blob = await apiviewfactura(cufe,uuid)   
          this.loading = false
          window.console.log('blobbbb', blob);
          this.url = URL.createObjectURL(blob);  
          
        },
        cerrar() { 
            this.dialog = false;
            if(this.emitir_refresh){
              this.$emit('fact_dgi_desvinculado')
            }
        }, 
        async enviar(){ 
            
        },
        async desvincularFactura(){
          const r = await this.$refs.refdesvincular_factura.openmodal(this.recibo)
          this.emitir_refresh = r
        }
      },
    };
  </script>
  